import { EmployerViewModel } from '@fora-monorepo/employer-my-pages-common/types';

import { mockFAGroups } from './mockFAGroups';

export const mockEmployer: EmployerViewModel = {
  partnerNumber: '0030000356',
  organizationName: 'HÄLLS MÅLERI AB',
  organizationNumber: '5564065356',
  vatRegistrationNumber: null,
  companyFormCode: '49',
  organizationStatus: null,
  isForeignOrganization: false,
  address: {
    streetAddress: 'BOX 4028',
    coAddress: 'C/O HÄLLS MÅLERI AB',
    postalCode: '46104',
    city: 'TROLLHÄTTAN',
    countryCode: 'SE',
    addressType: 'Standard Address',
  },
  contact: {
    phone: '',
    mobile: null,
    email: null,
  },
  faGroups: mockFAGroups.withVaryingTimeSpans, // Change to different FOK/FAGroup setups here
  agreementNumber: '00000000004010000083',
  insuranceAgreementValidFromDate: '2024-03-01',
};
